import React from 'react';
import { motion } from 'framer-motion';
export const Terms: React.FC = () => {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="bg-white" data-id="element-580">
      {/* Hero Section */}
      <section className="bg-black text-white py-12 md:py-16" data-id="element-581">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-582">
          <motion.div className="max-w-3xl mx-auto text-center" initial="hidden" animate="visible" variants={fadeIn} data-id="element-583">
            <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-4" data-id="element-584">
              Terms & Conditions
            </h1>
            <p className="text-lg text-gray-300" data-id="element-585">
              Please read these terms carefully before engaging our services.
            </p>
          </motion.div>
        </div>
      </section>
      {/* Terms Content */}
      <section className="py-12 md:py-16 bg-white" data-id="element-586">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-587">
          <motion.div className="max-w-3xl mx-auto" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} data-id="element-588">
            <div className="prose prose-lg max-w-none" data-id="element-589">
              <h2 data-id="element-590">1. Service Definition</h2>
              <p data-id="element-591">
                Debt Rescue ("we," "us," "our") provides a service connecting
                limited company owners ("clients," "you," "your") with
                third-party buyers who are willing to take over limited
                companies with existing liabilities and challenges. Our service
                includes the sourcing of suitable buyers and facilitation of the
                business transfer process.
              </p>
              <h2 data-id="element-592">2. Fees Payable</h2>
              <p data-id="element-593">
                Our fees are clearly set out on our Services & Pricing page.
                Payment is required in full before we commence sourcing a buyer
                for your company. Additional fees may apply for particularly
                complex cases, which will be discussed and agreed upon before
                any work commences.
              </p>
              <h2 data-id="element-594">3. No Financial Advice Disclaimer</h2>
              <p data-id="element-595">
                Debt Rescue does not provide financial, legal, or insolvency
                advice. We are not financial advisors, solicitors, or insolvency
                practitioners. Our service is limited to sourcing potential
                buyers for your limited company. We strongly recommend that you
                seek independent financial and legal advice before proceeding
                with our services.
              </p>
              <h2 data-id="element-596">4. No Guarantee of Buyer Outcome</h2>
              <p data-id="element-597">
                While we make every effort to source suitable buyers for your
                company, we cannot guarantee that a buyer will be found or that
                a successful transfer will be completed. Various factors outside
                our control may affect the outcome, including but not limited to
                the nature and extent of company liabilities, market conditions,
                and legal complexities.
              </p>
              <h2 data-id="element-598">5. Confidential Handling</h2>
              <p data-id="element-599">
                We treat all client information with strict confidentiality.
                Information about your company will only be shared with
                potential buyers after appropriate non-disclosure agreements are
                in place. We will not disclose your identity or company details
                to any third parties without your express consent, except where
                required by law.
              </p>
              <h2 data-id="element-600">6. Liability Limits</h2>
              <p data-id="element-601">
                Our liability to you for any losses arising from our services is
                limited to the amount of fees paid by you to us. We are not
                liable for any consequential losses, loss of profit, damage to
                reputation, or any other indirect losses arising from our
                services.
              </p>
              <h2 data-id="element-602">7. Payment Policy</h2>
              <p data-id="element-603">
                Payment can be made via bank transfer or card payment (subject
                to a 3% processing fee). All fees are non-negotiable and must be
                paid in full before services commence. VAT may be applicable and
                will be clearly indicated on invoices where relevant.
              </p>
              <h2 data-id="element-604">8. Refund Policy</h2>
              <p data-id="element-605">
                If we are unable to source a suitable buyer for your company
                within 90 days of payment, you may be eligible for a partial
                refund of 50% of the fee paid. No refunds will be issued if you
                decide to withdraw from the process after we have commenced
                work, or if you fail to provide requested information or
                documentation in a timely manner.
              </p>
              <h2 data-id="element-606">9. Communication Methods</h2>
              <p data-id="element-607">
                By engaging our services, you agree to communicate with us via
                the channels provided (WhatsApp, Telegram, email). You
                acknowledge that these communication methods are provided for
                convenience and that, while we take reasonable security
                precautions, no electronic communication method is entirely
                secure.
              </p>
              <h2 data-id="element-608">10. Jurisdiction</h2>
              <p data-id="element-609">
                These terms and conditions are governed by the laws of England
                and Wales. Any disputes arising from these terms or our services
                shall be subject to the exclusive jurisdiction of the courts of
                England and Wales.
              </p>
              <h2 data-id="element-610">11. Changes to Terms</h2>
              <p data-id="element-611">
                We reserve the right to modify these terms and conditions at any
                time. Changes will be posted on our website and will be
                effective immediately upon posting. Your continued use of our
                services after any changes indicates your acceptance of the
                modified terms.
              </p>
              <h2 data-id="element-612">12. Contact</h2>
              <p data-id="element-613">
                If you have any questions about these terms and conditions,
                please contact us via the methods provided on our Contact page.
              </p>
              <p className="text-sm text-gray-500 mt-12" data-id="element-614">
                Last updated: {new Date().toLocaleDateString('en-GB')}
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
};